import vue from 'vue'
import axios from './axios'

const apiContent = {
  //登录接口
  login: (data) => {
    return axios('index/common/adminlogin', data)
  },
  //1.顾问
  //  1.1 顾问列表
  gwList: (data) => {
    return axios('index/Administrators/adviserlist', data)
  },
  //  顾问日志
  listGwLog: (data) => {
    return axios('index/Administrators/dviserjournal', data)
  },
  //  1.2   顾问详情
  gwDetail: (data) => {
    return axios('index/administrators/advisersel', data)
  },
  //  1.3  顾问删除
  gwDel: (data) => {
    return axios('index/administrators/dviserdel', data)
  },
  // 1.4 修改顾问详情
  gwEdit: (data) => {
    return axios('index/administrators/editAdviser', data)
  },
  //  1.5 冻结
  gwDong: (data) => {
    return axios('index/administrators/dviserlocking', data)
  },
  //  1.6 顾问权限
  gwQuanx: (data) => {
    return axios('index/administrators/getadminCity', data)
  },
  //  1.7 修改顾问权限
  gwQuanxEdit: (data) => {
    return axios('index/administrators/jurisdiction', data)
  },
  //  1.8 创建顾问创建
  gwcjList: (data) => {
    return axios('index/Administrators/establish', data)
  },
  //  1.9 重置密码
  gwChongz: (data) => {
    return axios('index/Administrators/dviserreset', data)
  },
  //  机构重置
  jgChongz: (data) => {
    return axios('index/Administrators/userreset', data)
  },
  //  1.10 顾问日志列表
  gwRizhi: (data) => {
    return axios('index/Administrators/dviserjournal', data)
  },
  //  1.11 创建顾问-账号从属
  gwcsList: (data) => {
    return axios('index/index/zongar', data)
  },
  //  1.12 创建顾问-管辖城市
  gxcsList: (data) => {
    return axios('index/index/getadminCity', data)
  },
  //  1.13 全部城市
  cityAll: (data) => {
    return axios('index/Administrators/cityAdviser', data)
  },
  // 2.候选人
  //  2.1候选人列表
  hxrList: (data) => {
    return axios('index/Administrators/candidate', data)
  },
  //  2.1.1.1 候选人详情
  hxrDetail: (data) => {
    return axios('index/Administrators/trustsel', data)
  },
  //    2.1.1.2 候选人的简历详情
  detailResume: (data) => {
    return axios('index/Administrators/showResume', data)
  },
  //    候选人日志列表
  listCandidateLog: (data) => {
    return axios('index/Administrators/listCandidateLog', data)
  },
  //    简历删除
  toResemeDetele: (data) => {
    return axios('index/Administrators/delresume', data)
  },
  //  求职信删除
  toQinzhiDetele: (data) => {
    return axios('index/Administrators/delcover', data)
  },
  //  求职信详情
  emailDetail: (data) => {
    return axios('index/Administrators/showCoverLetterr', data)
  },
  //      2.1.1.3 候选人的简历的标签列表
  resumeLabelList: (data) => {
    return axios('index/Administrators/tagsel', data)
  },
  //      2.1.1.4 候选人的简历标签的删除
  deleteLabel: (data) => {
    return axios('index/Administrators/deltag', data)
  },
  //      2.1.1.6 候选人的求职信详情

  //  2.1.1候选人列表和机构列表删除
  hxrAndjgDel: (data) => {
    return axios('index/administrators/userdel', data)
  },
  //  指定机构移除双选会
  orgDelShuangXuanHui: (data) => {
    return axios('index/Administrators/orgDelShuangXuanHui', data)
  },
  //  2.1.2候选人信任和机构信任状态
  hxrAndjgTrust: (data) => {
    return axios('index/Administrators/trust', data)
  },
  //  2.1.3 候选人锁定和机构锁定状态
  hxrAndjgLock: (data) => {
    return axios('index/Administrators/userlocking', data)
  },
  //  双选会地区设置
  sxhAddress: (data) => {
    return axios('index/Administrators/setOrgNationwide', data)
  },
  //  双选会地区设置
  sxhAddress2: (data) => {
    return axios('index/Admintwo/setOrgNationwide', data)
  },
  //  2.1.4 重置密码
  hxrAndjgSet: (data) => {
    return axios('index/administrators/userreset', data)
  },
  //  2.2 表单列表
  hxrForm: (data) => {
    return axios('index/Administrators/formlist', data)
  },
  //  2.7 创建表单
  hxrChuangj: (data) => {
    return axios('index/Administrators/addfrom', data)
  },
  //  2.8 简历排名
  hxrPaim: (data) => {
    return axios('index/Administrators/recommended', data)
  },
  hxrPaim2: (data) => {
    return axios('index/Administrators/candidateranking', data)
  },

  //  2.9 简历禁止推荐
  hxrPaimtuij: (data) => {
    return axios('index/Administrators/prohibit', data)
  },
  //  2.10 候选人简历审核列表
  hxrpmShenh: (data) => {
    return axios('index/Administrators/jlexamine', data)
  },
  //  2.10 候选人求职信审核列表
  hxrqzShenh: (data) => {
    return axios('index/Administrators/listCoverLetterrSH', data)
  },
  //  简历审核
  shenheResume: (data) => {
    return axios('index/Administrators/adrsh', data)
  },
  //  求职信审核
  shenheQiuzhi: (data) => {
    return axios('index/Administrators/coverLetterrSH', data)
  },
  //  2.10 候选人基本信息审核列表
  hxrXinxShenh: (data) => {
    return axios('index/Administrators/information', data)
  },
  //  基本信息审核
  shenheUserInfo: (data) => {
    return axios('index/Administrators/adopt', data)
  },
  //  2.11 候选人和机构添加到表单选择列表
  hxrAddFormList: (data) => {
    return axios('index/Administrators/formname', data)
  },
  //  添加双选会
  orgAddShuangXuanHui: (data) => {
    return axios('index/Administrators/orgAddShuangXuanHui', data)
  },
  //  2.12 候选人和机构添加到表单选择列表
  hxrAddForm: (data) => {
    return axios('index/Administrators/formadd', data)
  },
  //  一键邀请
  addAllreg: (data) => {
    return axios('index/Administrators/sendPhoneNoticeMessage', data)
  },
  //3.机构管理
  //3.1 机构管理列表
  jgList: (data) => {
    return axios('index/Administrators/listOrganization', data)
  },
  // 3.1.1  推荐到首页
  jgCommend: (data) => {
    return axios('index/administrators/commend', data)
  },
  // 3.1.2  机构详情
  jgDetailE: (data) => {
    return axios('index/Administrators/jigouedit', data)
  },
  //  机构日志
  listorgLog: (data) => {
    return axios('index/Administrators/listorgLog', data)
  },

  // 3.1.2.1  基本信息审核通过不通过
  jgDetailShen: (data) => {
    return axios('index/Administrators/jgxxsh', data)
  },
  // 3.2 候选人和机构表单 接口同候选人表单列表
  //  3.2.1 表单列表详情
  hjFormD: (data) => {
    return axios('index/Administrators/formsel', data)
  },
  //  3.2.1.1 表单列表详情删除
  hjFormDE: (data) => {
    return axios('index/Administrators/delbiaodan', data)
  },
  //  3.3.1.1 对公转账列表
  jgDuiGongZhuanZhang: (data) => {
    return axios('index/Administrators/transfer', data)
  },
  //  3.3.1.1.1 对公转账到账
  jgZhuanZhangDaoZhang: (data) => {
    return axios('index/Administrators/accounts', data)
  },
  //  3.3.1.1.2 对公转账拒绝
  jgZhuanZhangJuJue: (data) => {
    return axios('index/Administrators/refuse', data)
  },
  //  3.3.1.1.3 对公转账详情
  jgZhuanZhangDetail: (data) => {
    return axios('index/Administrators/transfersel', data)
  },
  //  3.3.1.2 资金冻结列表
  jgZiJinDongJie: (data) => {
    return axios('index/Administrators/frozen', data)
  },
  //  3.3.1.2.1资金冻结退费
  jgZiJinDongJieTuiFei: (data) => {
    return axios('index/Administrators/refund', data)
  },
  //  3.3.1.2.2资金冻结发放扣款
  jgZiJinDongJieFK: (data) => {
    return axios('index/Administrators/fafang', data)
  },
  //  3.4. 审核
  //   3.4.1.1  职位发布审核列表
  jgZhiw: (data) => {
    return axios('index/Administrators/positionsh', data)
  },
  //   3.4.1.1.1  职位详情
  jgZhiwXqing: (data) => {
    return axios('index/Administrators/editposition', data)
  },
  //   3.4.1.1.2  职位详情审核
  jgZhiwXqingShen: (data) => {
    return axios('index/Administrators/shgn', data)
  },
  //   3.4.1.1.3  职位删除
  jgZhiwdel: (data) => {
    return axios('index/Administrators/deljobs', data)
  },
  //   3.4.1.2  基本信息变更审核列表
  jgXinXi: (data) => {
    return axios('index/Administrators/orglist', data)
  },

  // 3.5  创建机构账号
  jgaddorg: (data) => {
    return axios('index/Administrators/addorg', data)
  },
  // 3.6  发票管理
  //   3.6.1发票列表
  jgFaPiao: (data) => {
    return axios('index/Administrators/controloverinvoices', data)
  },
  //   3.6.2同意开发票
  jgKaiFaPiao: (data) => {
    return axios('index/Administrators/drawabill', data)
  },
  //   3.6.3拒绝开发票
  jgBuKaiFaPiao: (data) => {
    return axios('index/Administrators/refusalInvoice', data)
  },
  //   3.6.4发票详情
  jgFaPiaoDetail: (data) => {
    return axios('index/Administrators/invoiceedit', data)
  },

  // 8  密码修改
  gaiPass: (data) => {
    return axios('index/Common/editpass', data)
  },
  //  表单信息删除
  formItemDel: (data) => {
    return axios('index/Administrators/delbiaodan', data)
  },
  // 4  职位管理
  // 4.1  职位列表
  zwList: (data) => {
    return axios('index/Administrators/positionlist', data)
  },
  // 4.3  职位表单详情列表\
  //  职位推荐到首页
  zwCommend: (data) => {
    return axios('index/Administrators/recommendJob', data)
  },
  // 职位表单列表 --- 2.2
  // 创建表单   --- 2.7
  //  推荐职位
  tuijianzhiwei: (data) => {
    return axios('index/Administrators/tuijianzhiwei', data)
  },
  //  推荐简历
  tuijianjianli: (data) => {
    return axios('index/Administrators/tuijianjianli', data)
  },
  // 5 我的业绩
  yejiList: (data) => {
    return axios('index/Administrators/achievement', data)
  },
  //  6 我的日志
  myRizhi: (data) => {
    return axios('index/Administrators/wodejournal', data)
  },
  // 7站内信
  //  添加站内信
  addZnx: (data) => {
    return axios('index/Administrators/createInsideLetters', data)
  },
  //  发送的站内信列表
  myPostZneList: (data) => {
    return axios('index/Administrators/listMyInsideLetters', data)
  },
  //  发送的站内信删除
  myPostZnxDel: (data) => {
    return axios('index/Administrators/delMyInsideLetters', data)
  },
  //  发送的站内信详情
  myPostZneDetail: (data) => {
    return axios('index/Administrators/showMyInsideLetters', data)
  },
  //  收到的站内信
  myGetZneList: (data) => {
    return axios('index/Administrators/listMyInsideLettersObtain', data)
  },
  //  收到的站内信详情
  myGetZneDetail: (data) => {
    return axios('index/Administrators/showMyInsideLettersObtain', data)
  },
  //  收到的站内信删除
  myGetZneDel: (data) => {
    return axios('index/Administrator/delMyInsideLettersObtain', data)
  },
  //  收到的咨询
  myGetZxList: (data) => {
    return axios('index/Administrators/consultation', data)
  },
  //  收到的咨询删除
  myGetZxDel: (data) => {
    return axios('index/Administrators/delconsultation', data)
  },
  //  收到的咨询详情
  myGetZxDetail: (data) => {
    return axios('index/Administrators/insidecont', data)
  },
  //  回复咨询
  myGetZxHuifu: (data) => {
    return axios('index/Administrators/replyinside', data)
  },
  //  收到的投诉
  myGetTsList: (data) => {
    return axios('index/Administrators/complaint', data)
  },
  //  收到的投诉删除
  myGetTsDel: (data) => {
    return axios('index/Administrators/delcomplaint', data)
  },
  //  收到的投诉详情
  myGetTsDetail: (data) => {
    return axios('index/Administrators/inscomplaint', data)
  },

  //  投书回复
  myGetTsHuifu: (data) => {
    return axios('index/Administrators/repcomplaint', data)
  },
  // 广告管理
  // 1.获取广告
  advertisement: (data) => {
    return axios('index/Administrators/advertisement', data)
  },
  // 上传图片
  file: (data) => {
    return axios('/index/Other/uploadadmin', data, 'post', false)
  },
  // 保存广告
  saveBanner: (data) => {
    return axios('/index/Administrators/adveredit', data,)
  },
  // 候选人排名城市
  region: (data) => {
    return axios('/index/Administrators/kxprovince', data,)
  },
  // 简历添加标签
  addLabel: (data) => {
    return axios('/index/Administrators/tagname', data,)
  },
  //站内信  同意/拒绝应聘
  znxChiocePass: (data) => {
    return axios('/index/Candidate/approvalInterviewRecommender', data)
  },
  caiwu1: (data) => {
    return axios('/index/Administrators/ymDongJieLog', data)
  },
  caiwu2: (data) => {
    return axios('/index/Administrators/ymKouKuanLog', data)
  },
  caiwu3: (data) => {
    return axios('/index/Administrators/ymYongJinLog', data)
  },
  caiwu4: (data) => {
    return axios('/index/Administrators/xjChongZhiLog', data)
  },
  // 获取未读的站内信
  getZnx: (data) => {
    return axios('/index/Administrators/adminSHCount', data)
  },
  chuliZnx: (data) => {
    return axios('/index/Administrators/consultationProcessed', data)
  },
  getNewList: (data) => {
    return axios('/index/Index/listNews', data)
  },
  getNewList2: (data) => {
    return axios('/index/Article/articleList', data)
  },
  addNews: (data) => {
    return axios('/index/Administrators/addNews', data)
  },
  addNews2: (data) => {
    return axios('/index/Article/add', data)
  },
  newDelete: (data) => {
    return axios('/index/Administrators/delNews', data)
  },
  newDelete2: (data) => {
    return axios('/index/Article/del', data)
  },


  newDetail: (data) => {
    return axios('/index/Index/showNews', data)
  },
  newDetail2: (data) => {
    return axios('/index/Article/getInfo', data)
  },
  //  邀请码刷新
  refreshUserInvitationCode: (data) => {
    return axios('/index/Administrators/refreshUserInvitationCode', data)
  },
  //  邀请统计
  userInvitationStatistics: (data) => {
    return axios('/index/Administrators/userInvitationStatistics', data)
  },
  //  候选人邀请
  userInvitationCandidateList: (data) => {
    return axios('/index/Administrators/userInvitationCandidateList', data)
  },
  //  机构邀请列表
  userInvitationOrgList: (data) => {
    return axios('/index/Administrators/userInvitationOrgList', data)
  },
  //  职位推荐数量列表
  recommendPositionList: (data) => {
    return axios('/index/Administrators/recommendPositionList', data)
  },
  xjAutoTiXianLogList: (data) => {
    return axios('/index/Administrators/xjAutoTiXianLogList', data)
  },
  xjAutoTiXianLogListShow: (data) => {
    return axios('/index/Administrators/xjAutoTiXianLogListShow', data)
  },
  xjTiXianReportForms: (data) => {
    return axios('/index/Administrators/xjTiXianReportForms', data)
  },
  setPersonnelOfficial: (data) => {
    return axios('/index/Administrators/setPersonnelOfficial', data)
  },

  setWebSite: (data) => {
    return axios('/index/Administrators/setWebSite', data,'get')
  },
  setWebSite2: (data) => {
    return axios('/index/Administrators/setWebSite', data)
  },
  setOfficialOrg: (data) => {
    return axios('/index/Administrators/setOfficialOrg', data)
  },
  recommendUser: (data) => {
    return axios('/index/Administrators/recommendUser', data)
  },
  pvIpStatistics: (data) => { //  统计图
    return axios('/index/Administrators/pvIpStatistics', data)
  },
  orgNumClassifyStatistics: (data) => { //  统计图2
    return axios('/index/Administrators/orgNumClassifyStatistics', data)
  },
  // https://htjk.zexian.org.cn/index/Administrators/resumeDeliveryStatistics
  resumeDeliveryStatistics: (data) => { //  统计图2
    return axios('/index/Administrators/resumeDeliveryStatistics', data)
  },


  changeMessageState: (data) => { //  修改站内信状态
    return axios('/index/Administrators/changeMessageState', data)
  },
  changeMessageComplaintsState: (data) => { //  修改站内信状态
    return axios('/index/Administrators/changeMessageComplaintsState', data)
  },
  orgNumClassifyStatisticsByTime: (data) => { //  统计图3
    return axios('/index/Administrators/orgNumClassifyStatisticsByTime', data)
  },
  userNumClassifyStatisticsByTime: (data) => { //  统计图3
    return axios('/index/Administrators/userNumClassifyStatisticsByTime', data)
  },
  // 1.目前职业概况 所属领域
  editClassification: (data) => {
    return axios('index/index/classification', data)
  },
  // 省市县三级列表（可选）
  getkexuanCategoryDistrict: (data) => {
    return axios('/index/index/getkexuanCategoryDistrict', data)
  },
  // 上传图片
  file2: (data) => {
    return axios('/index/Other/uploadImageAdmin', data, 'post', false)
  },
  setOrgInfo: (data) => {
    return axios('/index/Administrators/perfectEdit', data)
  },
  // 添加双选会
  addCustomSXH: (data) => {
    return axios('/index/Administrators/addCustomSXH', data)
  },// 添加双选会
  addCustomSXH2: (data) => {
    return axios('/index/Admintwo/addCustomSXH', data)
  },
  //  获取双选会列表
  listCustomSXH: (data) => {
    return axios('/index/Administrators/listCustomSXH', data)
  },
  //  获取双选会列表
  listCustomSXH2: (data) => {
    return axios('/index/Admintwo/listCustomSXH', data)
  },
  // 双选会报名入口开关
  setSXHApplyForm: (data) => {
    return axios('/index/Administrators/setSXHApplyForm', data)
  },
  // 双选会报名入口开关
  setSXHApplyForm2: (data) => {
    return axios('/index/Admintwo/setSXHApplyForm', data)
  },

  // 双选会前台展示开关
  setSXHOpen: (data) => {
    return axios('/index/Admintwo/setSXHOpen', data)
  },

  // 双选会详情
  showCustomSXH: (data) => {
    return axios('/index/Administrators/showCustomSXH', data)
  },
  // 双选会详情
  showCustomSXH2: (data) => {
    return axios('/index/Admintwo/showCustomSXH', data)
  },
  //  获取双选会报名列表
  showSHXApplyFormList: (data) => {
    return axios('/index/Administrators/showSHXApplyFormList', data)
  },
  showSHXCandidateList: (data) => {
    return axios('/index/Admintwo/showSHXCandidateList', data)
  },
  //  获取双选会报名列表
  showSHXApplyFormList2: (data) => {
    return axios('/index/Admintwo/showSHXApplyFormList', data)
  },
  setSXHOrgShowOrHidden: (data) => {
    return axios('/index/Administrators/setSXHOrgShowOrHidden', data)
  },
  setSXHOrgShowOrHidden2: (data) => {
    return axios('/index/Admintwo/setSXHOrgShowOrHidden', data)
  },
  //  删除双选会
  delCustomSXH: (data) => {
    return axios('/index/Administrators/delCustomSXH', data)
  },
  //  删除双选会
  delCustomSXH2: (data) => {
    return axios('/index/Admintwo/delCustomSXH', data)
  },
  //批量加入双选会
  orgAddSXH: (data) => {
    return axios('/index/Administrators/orgAddSXH', data)
  },
  orgAddSXH2: (data) => {
    return axios('/index/Admintwo/orgAddSXH', data)
  },
  CFFStatistics: (data) => {
    return axios('/index/Administrators/CFFStatistics', data)
  },
  //  9-11日添加
  //  获取求职人员列表
  qzList: (data) => {
    return axios('/index/Administrators/JobLists', data,'get')
  },
  //  添加求职人员
  addQz: (data) => {
    return axios('/index/Administrators/JobAdd', data)
  },
  //  修改求职人员信息
  editQz: (data) => {
    return axios('/index/Administrators/UpdatePersonnelInfo', data)
  },

  //  删除求职人员
  delQz: (data) => {
    return axios('/index/Administrators/DelPersonnelInfo', data,'get')
  },
  //  求职人员栏目--下载excel导入模板
  DownloadExcelModel: (data) => {
    return axios('/index/Administrators/DownloadExcelModel', data,'get')
  },
  //  上传导入求职人员
  upQzList: (data) => {
    return axios('/index/Administrators/importPersonnelInfo', data, 'post', false)
  },
  //  获取已推荐的职位列表
  ytzZhiwei: (data) => {
    return axios('/index/Administrators/recommendedJobs', data)
  },
  //  获取推荐职位感兴趣的人员列表
  ytzZhiweiList: (data) => {
    return axios('/index/Administrators/JobDetails', data)
  },
  postEmail: (data) => {
    return axios('/index/Administrators/personnelPushEmail', data)
  },
  zwDown: (data) => {
    return axios('/index/Administrators/auditJobOffline', data)
  },
  delOrgById: (data) => {
    return axios('/index/Administrators/delOrgById', data)
  },
  positionCans: (data) => {
    return axios('/index/Administrators/positionCans', data)
  },
  showPushResume: (data) => {
    return axios('/index/Administrators/showPushResume', data)
  },

}
const api = {
  apiContent
}
vue.prototype.$api = api